module.exports = __webpack_public_path__ + "static/media/yesbitComWhiteLogo.ca101ed9.png";